import { QuoteApiModel, QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';

export const ShouldAddMoreQuoteOptions = (quote: QuoteApiModel, maxQuoteOptions: number) =>
  SettingsCache.settings.Features.includes('ShowQuoteProtectionUnavailableMessage') &&
  maxQuoteOptions > quote.Options.length &&
  quote.Options.length === 1 &&
  quote.Options[0].CoverCost == 0 &&
  quote.Options[0].Covered > 0 &&
  (quote.Options[0].Extras.length > 0 || quote.Service.Tags.includes('QuoteApi'));

export const PolyFillQuoteOptions = (quote: QuoteApiModel, maxQuoteOptions: number) => {
  if (!ShouldAddMoreQuoteOptions(quote, maxQuoteOptions)) {
    return quote.Options;
  }

  const noProtectionOption: QuoteOptionApiModel = {
    ...quote.Options[0],
    Extras: [],
    AvailableExtras: [],
    Covered: 0,
    CoverPercentage: 0,
    CoverCost: 0,
    Unavailable: true
  };

  const maxProtectionOption: QuoteOptionApiModel = {
    ...quote.Options[0],
    Extras: [],
    AvailableExtras: [],
    Covered: 2500,
    CoverPercentage: 100,
    CoverCost: 0,
    Unavailable: true
  };

  const extendedBaseCoverAmount = 20;
  if (quote.Options[0].CoverPercentage === 100 && quote.Options[0].Covered > extendedBaseCoverAmount) {
    const fillerExtendedBaseOption: QuoteOptionApiModel = {
      ...quote.Options[0],
      Extras: [],
      AvailableExtras: [],
      Covered: extendedBaseCoverAmount,
      CoverPercentage: 99,
      CoverCost: 0,
      Unavailable: true
    };

    // 3 options then the value of the quote must exceed the value of this single option
    // 2 options means the value of the quote must be less than the max value of this single option
    return maxQuoteOptions == 3
      ? [quote.Options[0], fillerExtendedBaseOption, noProtectionOption]
      : [quote.Options[0], noProtectionOption];
  }

  // 3 options then the value of the quote must exceed the value of this single option
  // 2 options means the value of the quote must be less than the max value of this single option
  return maxQuoteOptions == 3 && quote.Options[0].CoverPercentage < 100
    ? [maxProtectionOption, quote.Options[0], noProtectionOption]
    : [quote.Options[0], noProtectionOption];
};

export const CollectionImageName = (collectionType: string) => {
  switch (collectionType) {
    case 'Collection':
      return 'Van';
    case 'Locker':
      return 'Locker';
    default:
      return 'Shop';
  }
};
